module.exports = __webpack_public_path__ + "static/media/RPG_330.c701286e.png";